import { Link } from "react-router-dom";
import { ReactComponent as BrandBB } from "../../../assets/img/brand_bb.svg";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { RxExit } from "react-icons/rx";

import "./style.scss";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import ModalTutorial from "../ModalTutorial";
import { useModal } from "context/ModalContext/Modal.context";

import ModalInformativo from "../ModalInformativo";

import { format } from "date-fns";
import { ptBR } from "date-fns/locale/pt-BR";
import { StageIds } from "utils/constants";
import UserNotifications from "../UserNotifications";
import { getExtrato } from "services/realization.service";
import { FaCheck, FaTrophy } from "react-icons/fa6";
import { updateUserProfile } from "services/profile.service";

const Header = () => {
  const { showModal, closeModal } = useModal();
  const { user, rule, currentStep, dates, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ruleUrl, setRuleUrl] = useState("");
  const [userName, setUserName] = useState("");
  const [isElegible, setIsElegible] = useState(false);
  const [viewExtrato, setViewExtrato] = useState(false);
  const [extratoInfos, setExtratoInfos] = useState<any[]>();

  async function fetchExtrato() {
    try {
      if (!user?.detail?._id || !user?.detail?.chave) {
        return;
      }
      const data = await getExtrato(user?.detail?._id, user?.detail?.chave);
      if (!data.length || data.length === 0) {
        return;
      }
      setExtratoInfos(data);
      setViewExtrato(true);
    } catch (e: any) {
      console.log(e);
    }
  }

  async function fetchRealization() {
    try {
      setIsElegible(true);
    } catch (e: any) {
      console.log(e);
    }
  }

  useEffect(() => {
    fetchRealization();
    fetchExtrato();
    if (!!user) {
      setUserName(user.name.split(" ")[0]);
    }
  }, [user]);

  useEffect(() => {
    if (!!rule) {
      setRuleUrl(rule.url);
    }
  }, [rule]);

  const showCrono = () => {
    const modalContent = (
      <div className="p-10 mx-auto my-0 text-center">
        {!!dates && (
          <>
            <h1 className="text-[#2D37F5] font-bold text-2xl mb-3">
              Confira o cronograma do prêmio
            </h1>
            {dates.map((item: any, index: number) => (
              <div
                key={index}
                className="w-full bg-[#f0f2f4] text-black p-5 text-left rounded mb-3"
              >
                <p>
                  <b>
                    {format(item.startDate, "dd'/'MM", {
                      locale: ptBR,
                    })}

                    {item.endDate ? (
                      <>
                        <span> a </span>
                        {format(item.endDate, "dd'/'MM", {
                          locale: ptBR,
                        })}
                      </>
                    ) : (
                      ""
                    )}
                  </b>
                </p>
                {item.title}
              </div>
            ))}

            <div className="flex items-center justify-center">
              <button
                className="px-4 py-3 font-bold uppercase text-blue-bb"
                onClick={closeModal}
              >
                Fechar
              </button>
            </div>
          </>
        )}
      </div>
    );

    showModal("crono", modalContent, "crono");
  };

  const showTutorial = () => {
    const tutorialId = () => {
      switch (currentStep?._id) {
        case StageIds.STAGE_UM_AVALIACAO:
          return "6787e5fde510835c7932dba3";
        case StageIds.STAGE_DOIS_AVALIACAO:
          return "67a521a53de8c3182e994da2";
        default:
          return "6787e5fde510835c7932dba3";
      }
    };

    showModal(
      "tutorial",
      <ModalTutorial onlyClose={true} tutorial_id={tutorialId()} />,
      "tutorial"
    );
  };

  useEffect(() => {
    async function fetchData() {
      if (!user?.extra.firstViewExtrato && viewExtrato) {
        setTimeout(() => {
          showExtrato();
        }, 2000);
        await updateUserProfile({
          _id: user?._id,
          extra: {
            ...user?.extra,
            firstViewExtrato: true,
          },
        });
      }
    }
    fetchData();
  }, [user?.extra, viewExtrato]);
  

  const showInfos = () => {
    showModal("informativos", <ModalInformativo />, "informativos");
  };

  const showExtrato = () => {
    const modalExtrato = (
      <div className="p-10 mx-auto my-0 text-center">
        {!!extratoInfos && (
          <>
            <h1 className="bg-[#f0f2f4] font-bold text-2xl mb-3">Extrato</h1>
            {extratoInfos.map((item: any, index: number) => (
              <div
                key={index}
                className={`${
                  item.classificada
                    ? "bg-[#2D37F5] text-white"
                    : "bg-[#f0f2f4] text-[#2D37F5]"
                } border border-[#2D37F5] font-semibold p-5 text-left rounded mb-3 flex flex-col justify-between`}
              >
                <div className="flex flex-row justify-between">
                  {item.title}
                  {item.classificada === true && (
                    <div className="flex items-center gap-1 uppercase">
                      <FaTrophy color={"#F6F630"} width={24} />
                      <span className="text-sm font-bold text-yellow-bb-1 font-bb">
                        Classificada
                      </span>
                    </div>
                  )}
                </div>
                {item.confirmado ? (
                  <div>
                    <p className="text-sm text-green-500 flex flex-row items-center">
                      <FaCheck width={24} />
                      Confirmada a participação
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="text-sm text-red-500 flex flex-row items-center">
                      <IoClose width={24} />
                      Participação não confirmada conforme a IN 403-1 item 8.5.2
                    </p>
                  </div>
                )}

                {/* Exibindo a tabela de premiação (valor bruto, IR, líquido) */}
                {item.premioIndividual && item.premioIndividual.length > 0 && (
                  <div className="mt-2">
                    <h2 className="font-bold text-sm">Detalhes do Prêmio</h2>
                    <table className="min-w-full table-auto border-collapse border border-[#2D37F5]">
                    <thead>
                      <tr className="bg-[#2D37F5] text-white">
                      <th className=" border border-[#2D37F5] text-left">Valor Bruto</th>
                      {/* <th className=" border border-[#2D37F5] text-left">Valor IR</th>
                      <th className=" border border-[#2D37F5] text-left">Valor Líquido</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {item.premioIndividual.map((premio: any) => (
                      <tr key={premio._id}>
                        <td className=" border border-[#2D37F5] text-left">{premio.valor_Bruto}</td>
                        {/* <td className=" border border-[#2D37F5] text-left">{premio.valorIR}</td>
                        <td className="border border-[#2D37F5] text-left">{premio.valor_Liquido}</td> */}
                      </tr>
                      ))}
                    </tbody>
                    </table>
                    <p className="text-sm mt-4">Atenção: O crédito na sua conta corrente será diferente do valor bruto devido a retenção de Imposto de Renda.</p>
                  </div>
                )}
              </div>
            ))}

            {/* Outras informações de impedimento e pré-requisitos */}
            {user?.detail.impedimento_pre_requisito && (
              <div className="bg-[#f0f2f4] text-[#2D37F5] font-semibold p-5 text-left rounded mb-3">
                <p>
                  <b>
                    Você não atingiu o cumprimento de pelo menos um dos requisitos
                    elencados na IN 403-1 item 8.7.1.1.
                  </b>
                </p>
                <p>
                  {
                    "Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > Extrato de Premiação > Prêmio BB 2S2024 > Indicadores."
                  }
                </p>
              </div>
            )}

            {user?.detail.impedido && (
              <div className="bg-[#f0f2f4] text-[#2D37F5] font-semibold p-5 text-left rounded mb-3">
                <p>
                  <b>Impedido</b>
                </p>
                <p>
                  {
                    "Você não atingiu o cumprimento do requisito elencado na IN 403-1 item 8.7.1.1.2"
                  }
                </p>
              </div>
            )}

            <div className="flex items-center justify-center">
              <button className="px-4 py-3 font-bold uppercase text-blue-bb" onClick={closeModal}>
                Fechar
              </button>
            </div>
          </>
        )}
      </div>

    );
    showModal("crono", modalExtrato, "crono");
  };

  return (
    <header className="bg-blue-bb text-yellow-bb py-[11px] px-[17.5px]">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          <div className="flex items-center">
            <button
              className="pr-4 text-2xl md:hidden text-white-bb"
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              {isMenuOpen ? <IoClose /> : <GiHamburgerMenu />}
            </button>
            <h1 className="flex items-center gap-[17px] pr-4 mr-4 text-yellow-bb font-bold text-lg font-title">
              <BrandBB /> Prêmio BB
            </h1>
            <div className="flex md:hidden">
              <nav className="gap-4 pl-4">
                <ul className="flex justify-end gap-4">
                  <li className="flex">
                    <UserNotifications />
                  </li>
                  <span className="text-sm text-white-bb">{userName}</span>
                  <li className="flex">
                    <button
                      onClick={() => signOut("/login")}
                      className="text-white-bb"
                    >
                      <RxExit size={22} />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          {!(
            user &&
            user.detail &&
            user.detail.tipo_de_acordo === "PREDEFINIDO" &&
            !user.detail.isBoss &&
            !user.detail.acessor
          ) && (
            <nav className="hidden gap-4 navigation md:flex">
              <ul className="flex itens-center">
                {!!isElegible && (
                  <li>
                    {/* <Link
                      to={
                        currentStep?._id ===
                        StageIds.STAGE_TRES_AVALIACAO_DIRETOR
                          ? "/evaluation-realization"
                          : currentStep?._id ===
                              StageIds.STAGE_DOIS_AVALIACAO &&
                            user?.detail.isBoss
                          ? "/evaluation-president"
                          : currentStep?._id ===
                              StageIds.STAGE_DOIS_AVALIACAO &&
                            !user?.detail.isBoss
                          ? "/winners"
                          : currentStep?._id === StageIds.STAGE_UM_AVALIACAO
                          ? "/evaluation"
                          : "/result"
                      }
                      className="p-[6px]"
                    >
                      Resultado Final
                    </Link> */}
                  </li>
                )}

                <li>
                  <button onClick={showCrono} className="text-white-bb">
                    Cronograma
                  </button>
                </li>

                <li>
                  <Link to={ruleUrl} target="_blank">
                    Regulamento
                  </Link>
                </li>
                <li>
                  <button onClick={showInfos} className="text-white-bb">
                    Informativo
                  </button>
                </li>
                <li>
                  <Link to="/winners">Resultado da Etapa 2</Link>
                </li>
                {viewExtrato && (
                  <li>
                    <button
                      onClick={showExtrato}
                      className="text-white-bb"
                    >
                      Extrato
                    </button>
                  </li>
                )}
                <li>
                  <Link to="/indicated-list">Lista de indicados</Link>
                </li>
                <Link to={"/result"}>
                  Resultado Final
                </Link>
              </ul>
            </nav>
          )}
        </div>

        <div className="items-center hidden gap-4 md:flex">
          <ul className="flex itens-center md:items-end gap-r">
            <li className="flex pr-4 notify">
              <UserNotifications />
            </li>
            <li className="flex gap-2 username">
              <div className="flex gap-4">
                <span className="pl-4 text-sm text-white-bb">{userName}</span>
                <button
                  onClick={() => signOut("/login")}
                  className="text-white-bb"
                >
                  <RxExit size={22} />
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {isMenuOpen &&
        !(
          user &&
          user.detail &&
          user.detail.tipo_de_acordo === "PREDEFINIDO" &&
          !user.detail.isBoss &&
          !user.detail.acessor
        ) && (
          <nav className="py-4 text-white md:hidden bg-blue-bb md:text-yellow-bb">
            <ul className="flex flex-col items-start gap-4 px-4">
              {!!rule && (
                <>
                  {!isElegible && (
                    <li>
                      <Link to="/realizations" className="p-[6px]">
                        Realizações
                      </Link>
                    </li>
                  )}
                  {/* <li>
                    <button onClick={showCrono} className="p-[6px]">
                      Cronograma
                    </button>
                  </li> */}
                  <li>
                    <Link
                      to={ruleUrl}
                      target="_blank"
                      className="p-[6px] block"
                    >
                      Regulamento
                    </Link>
                  </li>
                  <li>
                    <button onClick={showInfos} className="p-[6px]">
                      Informativo
                    </button>
                  </li>
                  {viewExtrato && (
                    <li>
                      <button
                        onClick={showExtrato}
                        className="text-white-bb px-4"
                      >
                        Extrato
                      </button>
                    </li>
                  )}
                </>
              )}
              {!isElegible && (
                <li>
                  <button
                    onClick={showTutorial}
                    className="p-[9px] px-4 block text-left bg-yellow-bb text-blue-bb rounded-md font-bold"
                  >
                    REVER TUTORIAL
                  </button>
                </li>
              )}
            </ul>
          </nav>
        )}
    </header>
  );
};

export default Header;
